import React, { useState } from "react";

//redux
import { useDispatch } from "react-redux";

//types
import { OPEN_OUT_OF_COUNTRY_DIALOG } from "../../store/outOfCountryUser/types";

const OutOfCountryUserCard = ({ data }) => {
    const dispatch = useDispatch();

    const handleEditClick = () => {
        dispatch({ type: OPEN_OUT_OF_COUNTRY_DIALOG, payload: data });
    };

    const getStatusBadge = () => {
        if (data?.countries?.universal?.isActive) {
            return <span className="badge bg-success">Enabled</span>;
        } else {
            return <span className="badge bg-danger">Disabled</span>;
        }
    };

    return (
        <div className="col-md-6">
            <div className="card p-4 h-100">
                <div className="d-flex flex-row justify-content-between align-items-center mb-3">
                    <h4 className="text-white mb-0">Universal Access</h4>
                    {getStatusBadge()}
                </div>

                <div className="mb-3">
                    <p className="text-light">
                        <strong>Access Code Status:</strong>
                    </p>
                    <p className="text-muted">
                        {data?.countries?.universal?.isActive
                            ? "Access code is currently enabled"
                            : "Access code is currently disabled"}
                    </p>
                </div>

                <div className="d-flex gap-2">
                    <button
                        className="btn btn-primary"
                        onClick={handleEditClick}
                    >
                        <i className="fas fa-edit"></i> Manage Access Code
                    </button>
                </div>
            </div>
        </div>
    );
};

export default OutOfCountryUserCard;
